import React, { } from 'react'

import AuthPanel from '../../login/AuthPanel'

// Body swapped for the canonical lib-core auth panel (opens on the
// registration form; email verification happens in-panel via the
// ConfirmationCode step). The redux-form EmailRegistrationForm, the
// registerWithEmail action wiring and the confirm-with-pin redirect are
// superseded; the route ('home/welcome/register/email') is unchanged.
const RegistrationPage = () => {
  return <AuthPanel initialState="register" />
}

export default RegistrationPage
